import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import fr from "./locales/fr.json";
import en from "./locales/en.json";

export const LANGUAGES = [
  { code: "fr", label: "Français", short: "FR" },
  { code: "en", label: "English", short: "EN" },
];
export const LANG_STORAGE_KEY = "cn_lang";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { fr: { translation: fr }, en: { translation: en } },
    fallbackLng: "fr",
    supportedLngs: ["fr", "en"],
    nonExplicitSupportedLngs: true,
    detection: { order: ["localStorage", "navigator"], lookupLocalStorage: LANG_STORAGE_KEY, caches: ["localStorage"], convertDetectedLanguage: (l) => String(l || "fr").slice(0, 2).toLowerCase() },
    interpolation: { escapeValue: false },
    returnNull: false,
  });

i18n.on("languageChanged", (lng) => { document.documentElement.lang = lng; });
document.documentElement.lang = i18n.language;

/** Traduction hors composant (pages remontées via key={lang} dans Layout). */
export const tr = (key, opts) => i18n.t(key, opts);

export default i18n;
